import { useQuery } from '@tanstack/react-query'
import { JsonRpcError } from '~/types'
import { Currency, WithdrawStrategy } from '../types'

/**
 * The fee and minimum are read from the server, never hardcoded here.
 *
 * They used to be constants in this file, and they drifted: this said the
 * minimum was 10 while the server rejected anything under 25, so a $15 request
 * passed client validation and came back as an error. Now that staff can change
 * the fee in the admin, a local copy would misquote the deduction as well.
 */
export const useWithdrawStrategy = (currency: Currency) => {
    return useQuery<WithdrawStrategy, JsonRpcError>({
        queryKey: ['bank.withdraw_strategy', currency?.name],
        queryFn: async () => {
            const res = await fetch('/rpc', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    id: 1,
                    method: 'bank.withdraw_strategy',
                    params: { target_currency: currency.name },
                }),
            })
            const data = await res.json()
            if (data.error) {
                throw data
            } else {
                return data.result
            }
        },
        enabled: !!currency?.name,
        retry: false,
    })
}
